<template>
  <v-card>
    <v-card-title class="headline">Notification Details</v-card-title>
    <v-card-text>
      <div class="notification-details">
        <img v-if="notification.data && notification.data.imageUrl" :src="notification.data.imageUrl" alt="Notification Image" width="250" class="notification-image">
        <div><strong>Title:</strong> {{ notification.title }}</div>
        <div><strong>Body:</strong> {{ notification.body }}</div>
        <div><strong>Date:</strong> {{ formattedDate }}</div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="$emit('close')">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ShowNotification',
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedDate() {
      return this.notification.timestamp ? new Date(this.notification.timestamp).toLocaleString() : '';
    }
  }
};
</script>

<style scoped>
.notification-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.notification-image {
  border-radius: 5px;
  margin-bottom: 10px;
  max-width: 100%;
  max-height: 350px;
  object-fit: contain;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
